export const GET_SUGGESTED_TAGS_REQUEST = 'GET_SUGGESTED_TAGS_REQUEST';
export const GET_SUGGESTED_TAGS_SUCCESS = 'GET_SUGGESTED_TAGS_SUCCESS';
export const GET_SUGGESTED_TAGS_FAILURE = 'GET_SUGGESTED_TAGS_FAILURE';

export const POST_SUGGESTED_TAGS_REQUEST = 'POST_SUGGESTED_TAGS_REQUEST';
export const POST_SUGGESTED_TAGS_SUCCESS = 'POST_SUGGESTED_TAGS_SUCCESS';
export const POST_SUGGESTED_TAGS_FAILURE = 'POST_SUGGESTED_TAGS_FAILURE'


export const getSuggestedTagsRequest = (value) => ({
    type: GET_SUGGESTED_TAGS_REQUEST,
    payload: {
        value
    }
});

export const getSuggestedTagsSuccess = (tags) => ({
    type: GET_SUGGESTED_TAGS_SUCCESS,
    payload: {
        tags
    }
});

export const getSuggestedTagsFailure = () => ({
    type: GET_SUGGESTED_TAGS_FAILURE
});

export const postSuggestedTagsRequest = (value) => ({
    type: POST_SUGGESTED_TAGS_REQUEST,
    payload: {
        value
    }
});

export const postSuggestedTagsSuccess = (tag) => ({
    type: POST_SUGGESTED_TAGS_SUCCESS,
    payload: {
        tag
    }
});

export const postSuggestedTagsFailure = () => ({
    type: POST_SUGGESTED_TAGS_FAILURE
});